import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q2 = [];

var entryPoint = [0, 0];

var selectedCount_Q2 = 0;

var routeMapSet_Q2 = 1;

var newPointDistanceQ2 = 0;

var plantArrayQ2 = [[], [], [], [], [], [], [], [], [], [], []];

var plantLeftArrayQ2 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q2 = new Phaser.Geom.Point(330, -200);

var leftQ2_p1 = new Phaser.Geom.Point(330, 192);

var leftExitWay_Q2 = new Phaser.Geom.Point(330, 1000);

var leftFinalRouteMap_Q2 = [leftEntrance_Q2, leftQ2_p1, leftExitWay_Q2];

var leftRouteMapSet_Q2 = 1;

var entrance_Q2 = new Phaser.Geom.Point(0, 0);

var exitWay_Q2 = new Phaser.Geom.Point(0, 0);

var centerQ2 = new Phaser.Geom.Point(960.5, 330.5);

var startPointQ2 = new Phaser.Geom.Point(960.5, 150.5);

var Q2_p1 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p2 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p3 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p4 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p5 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p6 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p7 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p8 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p9 = new Phaser.Geom.Point(1016.1, 159.3);
var Q2_p10 = new Phaser.Geom.Point(1016.1, 159.3);

// debugger

var coordinateArrayQ2 = [Q2_p1, Q2_p2, Q2_p3, Q2_p4, Q2_p5, Q2_p6, Q2_p7, Q2_p8, Q2_p9, Q2_p10];

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

export default class GameSceneQ2 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ2",
    });
  }

  preload() {
    this.load.image("BGQ2", "assets/Q2/BGQ2.png");

    this.load.image("D_BGQ2", "assets/Q2/D_BGQ2.png");

    this.load.image("L_curbQ2", "assets/Q2/L_curbQ2.png");

    this.load.image("hitBoxQ2", "assets/Q2/hitBoxQ2.png");
    this.load.image("curbQ2", "assets/Q2/curbQ2.png");
    this.load.image("rightPlotQ2", "assets/Q2/rightPlotQ2.png");
    this.load.image("whiteBoxQ2", "assets/Q2/whiteBoxQ2.png");

    this.load.image("leftGreyBoxQ2", "assets/Q2/leftGreyBoxQ2.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    ///audio end

    for (let i = 0; i < coordinateArrayQ2.length; i++) {
      Phaser.Math.RotateAround(coordinateArrayQ2[i], 960.5, 330.5, i * 0.628319);
    }

    this.BGQ2 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ2");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.scoreRefresh();

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0.2, 0.2).setVisible(false).setDepth(6);

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0).setDepth(2);

    this.curbQ2 = this.add.sprite(690, 67, "L_curbQ2").setOrigin(0).setDepth(2);
    this.add.sprite(960.5, 330.5, "rightPlotQ2").setOrigin(0.5, 0.5).setDepth(2);

    this.hitBoxQ2_1 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setDepth(2);
    this.hitBoxQ2_2 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(36).setDepth(2);
    this.hitBoxQ2_3 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(72).setDepth(2);
    this.hitBoxQ2_4 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(108).setDepth(2);
    this.hitBoxQ2_5 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(144).setDepth(2);
    this.hitBoxQ2_6 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(180).setDepth(2);
    this.hitBoxQ2_7 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(216).setDepth(2);
    this.hitBoxQ2_8 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(252).setDepth(2);
    this.hitBoxQ2_9 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(288).setDepth(2);
    this.hitBoxQ2_10 = this.add.sprite(960.5, 330.5, "hitBoxQ2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 1).setAlpha(0.1).setAngle(324).setDepth(2);

    this.whiteBoxQ2_1 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(0).setDepth(2);
    this.whiteBoxQ2_2 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(36).setDepth(2);
    this.whiteBoxQ2_3 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(72).setDepth(2);
    this.whiteBoxQ2_4 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(108).setDepth(2);
    this.whiteBoxQ2_5 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(144).setDepth(2);
    this.whiteBoxQ2_6 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(180).setDepth(2);
    this.whiteBoxQ2_7 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(216).setDepth(2);
    this.whiteBoxQ2_8 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(252).setDepth(2);
    this.whiteBoxQ2_9 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(288).setDepth(2);
    this.whiteBoxQ2_10 = this.add.sprite(960.5, 330.5, "whiteBoxQ2").setOrigin(0, 1).setVisible(false).setAngle(324).setDepth(2);

    this.leftGreyBoxQ2 = this.add.sprite(195, 109, "leftGreyBoxQ2").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    // this.Q2_ans = this.add.sprite(654.14,474.2, "qnBoard").setOrigin(0);

    this.Q2_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q2_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0).setDepth(2);

    this.Q2_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q2_leftDr = this.add.text(78, 578, "5", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q2_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q2_rightDr = this.add.text(715, 578, "10", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.85, 0.9).setDepth(6);

    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    // this.Q2_qn = this.add.sprite(20.14,473.2, "qnBoard").setOrigin(0);
    // this.Q2_ans = this.add.sprite(654.14,474.2, "ansBoard").setOrigin(0);

    this.anims.create({
      key: "floweringQ2",
      frames: this.anims.generateFrameNames("flowering3Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "Flower",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    this.waterPlantOnLeftQ2();

    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    // var graphics = this.add.graphics();

    // graphics.fillStyle(0xff0000, 1);

    // graphics.fillCircle(Q2_p1.x, Q2_p1.y, 4);
    // graphics.fillCircle(Q2_p2.x, Q2_p2.y, 4);
    // graphics.fillCircle(Q2_p3.x, Q2_p3.y, 4);
    // graphics.fillCircle(Q2_p4.x, Q2_p4.y, 4);
    // graphics.fillCircle(Q2_p5.x, Q2_p5.y, 4);
    // graphics.fillCircle(Q2_p6.x, Q2_p6.y, 4);
    // graphics.fillCircle(Q2_p7.x, Q2_p7.y, 4);
    // graphics.fillCircle(Q2_p8.x, Q2_p8.y, 4);
    // graphics.fillCircle(Q2_p9.x, Q2_p9.y, 4);
    // graphics.fillCircle(Q2_p10.x, Q2_p10.y, 4);
  }

  waterPlantOnLeftQ2() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ2.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q2[0].x, leftFinalRouteMap_Q2[0].y, leftFinalRouteMap_Q2[1].x, leftFinalRouteMap_Q2[1].y);
      },
      [],
      this
    );
  }

  showDeselect() {
    if (selectedCount_Q2 >= 2) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(finalRouteMap_Q2[0].x, finalRouteMap_Q2[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  startQuestionQ2() {
    //>//>>>hidden_console.log("startQ2");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q2[leftRouteMapSet_Q2-1],leftRouteMapSet_Q2-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q2[leftRouteMapSet_Q2 - 1], leftRouteMapSet_Q2 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (leftRouteMapSet_Q2 < leftFinalRouteMap_Q2.length - 1) {
          this.Q2_leftNr.setText(leftRouteMapSet_Q2);

          this.moveCanInitial(leftFinalRouteMap_Q2[leftRouteMapSet_Q2].x, leftFinalRouteMap_Q2[leftRouteMapSet_Q2].y, leftFinalRouteMap_Q2[leftRouteMapSet_Q2 + 1].x, leftFinalRouteMap_Q2[leftRouteMapSet_Q2 + 1].y);

          leftRouteMapSet_Q2 = leftRouteMapSet_Q2 + 1;
          //>//>>>hidden_console.log(leftRouteMapSet_Q2);
        } else {
          this.Q2_leftNr.setVisible(true);
          this.Q2_input.setVisible(true);

          this.startQuestionQ2();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ2.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ2[k5].length; l5++) {
        plantLeftArrayQ2[k5][l5].setTexture("flowering3Anim").play("floweringQ2");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ2[1][1].setTexture("flowering3Anim").play("floweringQ2");

    for (var k = 0; k < plantArrayQ2.length; k++) {
      for (var l = 0; l < plantArrayQ2[k].length; l++) {
        plantArrayQ2[k][l].setTexture("flowering3Anim").play("floweringQ2");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ2");
    //   this.scene.start('GameSceneQ3');

    // },[],this);

    this.removeClicking();
    this.changeScene();
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    ///
    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    //

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();

            attempts = 0;

            this.wipeSceneQ2();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ2");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ2");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ2");
              this.scene.start("GameSceneQ3");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        // if (gameState.attempted == 10) {
        //   gameState.gameWin = false;
        //   // this.scene.stop("TutorialScene");
        //   this.scene.start("EndScene");
        // }else if(){

        // }
        // else{

        // }
      },
      [],
      this
    );
  }

  wipeSceneQ2() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q2 = [];

    entryPoint = [0, 0];

    selectedCount_Q2 = 0;

    routeMapSet_Q2 = 1;

    newPointDistanceQ2 = 0;

    plantArrayQ2 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ2 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q2 = [leftEntrance_Q2,leftQ2_p1,leftExitWay_Q2];
    leftRouteMapSet_Q2 = 1;

    entrance_Q2.setTo(0, 0);

    exitWay_Q2.setTo(0, 0);

    Q2_p1.setTo(1016.1, 159.3);
    Q2_p2.setTo(1016.1, 159.3);
    Q2_p3.setTo(1016.1, 159.3);
    Q2_p4.setTo(1016.1, 159.3);
    Q2_p5.setTo(1016.1, 159.3);
    Q2_p6.setTo(1016.1, 159.3);
    Q2_p7.setTo(1016.1, 159.3);
    Q2_p8.setTo(1016.1, 159.3);
    Q2_p9.setTo(1016.1, 159.3);
    Q2_p10.setTo(1016.1, 159.3);
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q2 += 1;

      this.Q2_input.setText(selectedCount_Q2);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(finalRouteMap_Q2, this.getPointFromCode(xcode, ycode));

      selectedCount_Q2 -= 1;
      this.Q2_input.setText(selectedCount_Q2);

      //>//>>>hidden_console.log(finalRouteMap_Q2);
    }
  }

  updateRouteMap(xcode, ycode) {
    if (finalRouteMap_Q2.length <= 1) {
      finalRouteMap_Q2.push(this.getPointFromCode(xcode, ycode));
    } else {
      newPointDistanceQ2 = this.calculateDistance(finalRouteMap_Q2[0], this.getPointFromCode(xcode, ycode));

      //>//>>>hidden_console.log(newPointDistanceQ2);

      var routeMapLength_Q2 = finalRouteMap_Q2.length;

      for (var i = 0; i < routeMapLength_Q2 - 1; i++) {
        //>//>>>hidden_console.log(Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q2[0],finalRouteMap_Q2[i+1]));

        if (Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q2[0], finalRouteMap_Q2[i + 1]) > newPointDistanceQ2) {
          if (xcode == 0 && ycode == 0) {
            finalRouteMap_Q2.insert(i + 1, Q2_p1);
          } else if (xcode == 1 && ycode == 0) {
            finalRouteMap_Q2.insert(i + 1, Q2_p2);
          } else if (xcode == 0 && ycode == 1) {
            finalRouteMap_Q2.insert(i + 1, Q2_p3);
          } else if (xcode == 1 && ycode == 1) {
            finalRouteMap_Q2.insert(i + 1, Q2_p4);
          } else if (xcode == 0 && ycode == 2) {
            finalRouteMap_Q2.insert(i + 1, Q2_p5);
          } else if (xcode == 1 && ycode == 2) {
            finalRouteMap_Q2.insert(i + 1, Q2_p6);
          } else if (xcode == 0 && ycode == 3) {
            finalRouteMap_Q2.insert(i + 1, Q2_p7);
          } else if (xcode == 1 && ycode == 3) {
            finalRouteMap_Q2.insert(i + 1, Q2_p8);
          } else if (xcode == 0 && ycode == 4) {
            finalRouteMap_Q2.insert(i + 1, Q2_p9);
          } else if (xcode == 1 && ycode == 4) {
            finalRouteMap_Q2.insert(i + 1, Q2_p10);
          }
        } else {
          if (xcode == 0 && ycode == 0) {
            finalRouteMap_Q2.push(Q2_p1);
          } else if (xcode == 1 && ycode == 0) {
            finalRouteMap_Q2.push(Q2_p2);
          } else if (xcode == 0 && ycode == 1) {
            finalRouteMap_Q2.push(Q2_p3);
          } else if (xcode == 1 && ycode == 1) {
            finalRouteMap_Q2.push(Q2_p4);
          } else if (xcode == 0 && ycode == 2) {
            finalRouteMap_Q2.push(Q2_p5);
          } else if (xcode == 1 && ycode == 2) {
            finalRouteMap_Q2.push(Q2_p6);
          } else if (xcode == 0 && ycode == 3) {
            finalRouteMap_Q2.push(Q2_p7);
          } else if (xcode == 1 && ycode == 3) {
            finalRouteMap_Q2.push(Q2_p8);
          } else if (xcode == 0 && ycode == 4) {
            finalRouteMap_Q2.push(Q2_p9);
          } else if (xcode == 1 && ycode == 4) {
            finalRouteMap_Q2.push(Q2_p10);
          }
        }
        break;
      }
    }

    //>//>>>hidden_console.log(finalRouteMap_Q2);
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q2_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q2_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q2_p3;
    } else if (xcode == 1 && ycode == 1) {
      return Q2_p4;
    } else if (xcode == 0 && ycode == 2) {
      return Q2_p5;
    } else if (xcode == 1 && ycode == 2) {
      return Q2_p6;
    } else if (xcode == 0 && ycode == 3) {
      return Q2_p7;
    } else if (xcode == 1 && ycode == 3) {
      return Q2_p8;
    } else if (xcode == 0 && ycode == 4) {
      return Q2_p9;
    } else if (xcode == 1 && ycode == 4) {
      return Q2_p10;
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();

      if (selectedCount_Q2 == 2) {
        this.hideDeselect();

        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        //>2

        this.hintButton.removeInteractive();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q2_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q2[0] == Q2_p1) {
          entrance_Q2.setTo(1016, -200);
        } else if (finalRouteMap_Q2[0] == Q2_p2) {
          entrance_Q2.setTo(2078, 224);
        } else if (finalRouteMap_Q2[0] == Q2_p3) {
          entrance_Q2.setTo(2078, 330);
        } else if (finalRouteMap_Q2[0] == Q2_p4) {
          entrance_Q2.setTo(1106, 1000);
        } else if (finalRouteMap_Q2[0] == Q2_p5) {
          entrance_Q2.setTo(1016, 1000);
        } else if (finalRouteMap_Q2[0] == Q2_p6) {
          entrance_Q2.setTo(904, 1000);
        } else if (finalRouteMap_Q2[0] == Q2_p7) {
          entrance_Q2.setTo(814, 1000);
        } else if (finalRouteMap_Q2[0] == Q2_p8) {
          entrance_Q2.setTo(780, -200);
        } else if (finalRouteMap_Q2[0] == Q2_p9) {
          entrance_Q2.setTo(814, -200);
        } else if (finalRouteMap_Q2[0] == Q2_p10) {
          entrance_Q2.setTo(904, -200);
        }

        finalRouteMap_Q2.unshift(entrance_Q2);

        if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p1) {
          exitWay_Q2.setTo(1016, -200);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p2) {
          exitWay_Q2.setTo(2078, 224);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p3) {
          exitWay_Q2.setTo(2078, 330);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p4) {
          exitWay_Q2.setTo(1106, 1000);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p5) {
          exitWay_Q2.setTo(1016, 1000);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p6) {
          exitWay_Q2.setTo(904, 1000);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p7) {
          exitWay_Q2.setTo(814, 1000);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p8) {
          exitWay_Q2.setTo(780, -200);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p9) {
          exitWay_Q2.setTo(814, -200);
        } else if (finalRouteMap_Q2[finalRouteMap_Q2.length - 1] == Q2_p10) {
          exitWay_Q2.setTo(904, -200);
        }

        finalRouteMap_Q2.push(exitWay_Q2);

        this.moveCan(finalRouteMap_Q2[0].x, finalRouteMap_Q2[0].y, finalRouteMap_Q2[1].x, finalRouteMap_Q2[1].y);
      } else {
        config.audio.wrongAnswer.play();

        // this.Q2_ans.setTint(0xFFC2A2);

        //>3

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        ////

        this.Q2_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q2_rightDr.setFill("#C22300");
        this.Q2_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q2_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q2_rightDr.setFill("#2b2b2b");
            this.Q2_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q2[routeMapSet_Q2 - 1], routeMapSet_Q2 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q2 < finalRouteMap_Q2.length - 1) {
          this.moveCan(finalRouteMap_Q2[routeMapSet_Q2].x, finalRouteMap_Q2[routeMapSet_Q2].y, finalRouteMap_Q2[routeMapSet_Q2 + 1].x, finalRouteMap_Q2[routeMapSet_Q2 + 1].y);

          routeMapSet_Q2 = routeMapSet_Q2 + 1;
          //>//>>>hidden_console.log(routeMapSet_Q2);
        } else {
          ///
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          // sunshining stop

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();

              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  hitboxClickAndHoverHandle() {
    this.BGQ2.setTexture("BGQ2");
    this.curbQ2.setTexture("curbQ2");

    this.hitBoxQ2_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_1, 0, 0);
      },
      this
    );
    this.hitBoxQ2_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_2, 1, 0);
      },
      this
    );
    this.hitBoxQ2_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_3, 0, 1);
      },
      this
    );
    this.hitBoxQ2_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_4, 1, 1);
      },
      this
    );
    this.hitBoxQ2_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_5, 0, 2);
      },
      this
    );
    this.hitBoxQ2_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_6, 1, 2);
      },
      this
    );
    this.hitBoxQ2_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_7, 0, 3);
      },
      this
    );
    this.hitBoxQ2_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_8, 1, 3);
      },
      this
    );
    this.hitBoxQ2_9.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_9, 0, 4);
      },
      this
    );
    this.hitBoxQ2_10.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ2_10, 1, 4);
      },
      this
    );

    this.hitBoxQ2_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(1);
      },
      this
    );
    this.hitBoxQ2_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(2);
      },
      this
    );
    this.hitBoxQ2_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(3);
      },
      this
    );
    this.hitBoxQ2_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(4);
      },
      this
    );
    this.hitBoxQ2_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(5);
      },
      this
    );
    this.hitBoxQ2_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(6);
      },
      this
    );
    this.hitBoxQ2_7.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(7);
      },
      this
    );
    this.hitBoxQ2_8.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(8);
      },
      this
    );
    this.hitBoxQ2_9.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(9);
      },
      this
    );
    this.hitBoxQ2_10.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ2(10);
      },
      this
    );

    this.hitBoxQ2_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_7.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_8.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_9.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
    this.hitBoxQ2_10.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ2();
      },
      this
    );
  }

  //>5
  enableClicking() {
    this.hitBoxQ2_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_6.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_7.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_8.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_9.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ2_10.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ2_1.removeInteractive();
    this.hitBoxQ2_2.removeInteractive();
    this.hitBoxQ2_3.removeInteractive();
    this.hitBoxQ2_4.removeInteractive();
    this.hitBoxQ2_5.removeInteractive();
    this.hitBoxQ2_6.removeInteractive();
    this.hitBoxQ2_7.removeInteractive();
    this.hitBoxQ2_8.removeInteractive();
    this.hitBoxQ2_9.removeInteractive();
    this.hitBoxQ2_10.removeInteractive();

    console.log(attempts);

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }

    this.hintButton.removeInteractive();
  }

  showWhiteBoxQ2(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ2();

    if (position == 1) {
      this.whiteBoxQ2_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ2_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ2_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ2_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ2_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ2_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBoxQ2_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBoxQ2_8.setVisible(true);
    }
    if (position == 9) {
      this.whiteBoxQ2_9.setVisible(true);
    }
    if (position == 10) {
      this.whiteBoxQ2_10.setVisible(true);
    }
  }

  removeWhiteBoxQ2() {
    this.whiteBoxQ2_1.setVisible(false);
    this.whiteBoxQ2_2.setVisible(false);
    this.whiteBoxQ2_3.setVisible(false);
    this.whiteBoxQ2_4.setVisible(false);
    this.whiteBoxQ2_5.setVisible(false);
    this.whiteBoxQ2_6.setVisible(false);
    this.whiteBoxQ2_7.setVisible(false);
    this.whiteBoxQ2_8.setVisible(false);
    this.whiteBoxQ2_9.setVisible(false);
    this.whiteBoxQ2_10.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    if (selectedPoint == Q2_p1) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y + 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p2) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y + 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p3) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p4) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p5) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p6) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 20, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p7) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 40, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p8) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p9) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 0, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 40, selectedPoint.y + 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q2_p10) {
      plantArrayQ2[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ2[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 25, selectedPoint.y + 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    }

    // plantArrayQ2[plantSelectionCode][2] = this.add.sprite(selectedPoint.x + 10,selectedPoint.y + 50,"playSwayAnim").setScale(0.3).play("plantbudding");
    // plantArrayQ2[plantSelectionCode][3] = this.add.sprite(selectedPoint.x + 105,selectedPoint.y + 50,"playSwayAnim").setScale(0.3).play("plantbudding");
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    plantLeftArrayQ2[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x - 70, selectedPoint.y - 57, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ2[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x, selectedPoint.y - 60, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ2[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 70, selectedPoint.y - 60, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");

    plantLeftArrayQ2[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x - 40, selectedPoint.y + 10, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
    plantLeftArrayQ2[plantSelectionCode][4] = this.add
      .sprite(selectedPoint.x + 40, selectedPoint.y + 10, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");

    plantLeftArrayQ2[plantSelectionCode][5] = this.add
      .sprite(selectedPoint.x + 0, selectedPoint.y + 75, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q2 <= selectedCount_Q2 || leftRouteMapSet_Q2 < leftFinalRouteMap_Q2.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
